import React, { useState } from "react";
import "./PPQuizTaker.css";
import { Modal } from "react-bootstrap";
export const PPRetakeQuizDialog = ({
  mode = "",
  details,
  video,
  onHandleRetakeQuizz,
  onHandleReviewQuiz,
}) => {
  const [showRetakeQuizPopUp, setShowRetakeQuizPopUp] = useState(false);
  const handleClickOpen = () => {
    setShowRetakeQuizPopUp(true);
  };
  const handleRetake = () => {
    onHandleRetakeQuizz();
  };
  const handleReview = () => {
    onHandleReviewQuiz();
  };
  return (
    <>
      {details ? (
        <div className="d-flex flex-column">
          <button
            onClick={handleClickOpen}
            className={
              mode === "Graded"
                ? "ppQuizGradeBtn rounded-0"
                : "ppQuizPractBtn mr-2"
            }
          >
            {mode} Mode
          </button>
        </div>
      ) : (
        <React.Fragment>
          <div className="d-flex flex-row">
            <a
              className="ppQuizUrlTxt mr-1"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleReview();
              }}
            >
              Review Quiz{" "}
            </a>
            <span className="ppQuizUrlTxt mr-1"> |</span>
            <a
              className="ppQuizUrlTxt"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleClickOpen();
              }}
            >
              Retake Quiz
            </a>
          </div>
        </React.Fragment>
      )}
      <Modal
        show={showRetakeQuizPopUp}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="ppQuizRePopUpTxt">
          <p>
            {" "}
            Retaking this video quiz will erase the data from your previous
            attempt.
          </p>
          <p> Are you sure you want to retake this quiz? </p>
        </div>
        <div className="ppQuizRePopUpFooter">
          <button
            className="ppQuizRePopUpNoBtn mr-2"
            onClick={() => setShowRetakeQuizPopUp(false)}
          >
            No, Go Back
          </button>
          <button className="ppQuizRePopUpYesBtn" onClick={handleRetake}>
            Yes, Retake
          </button>
        </div>
      </Modal>
    </>
  );
};

export default PPRetakeQuizDialog;
